"use client";

export {
	useParams,
	usePathname as useRawPathname,
	useSearchParams,
} from "next/navigation";
export type { RedirectTarget, RedirectType } from "./navigation.core";
export {
	getPathname,
	Link,
	UnlocalizedLink,
	useLocale,
	usePathname,
	useRouter,
} from "./navigation.core";
export { notFound, permanentRedirect, redirect } from "./navigation.server";
